export const config = {
    appId: '3b553fed-122f-4dc2-b5a1-ae43d041c2e5',//5eb9db09-06fa-494f-b68f-eaaba6843c11 - 3b553fed-122f-4dc2-b5a1-ae43d041c2e5
    redirectUri: window.location.origin,
    scopes: ['openid','email','profile'],
    authority: `https://login.microsoftonline.com/3ea4ee53-5e07-4a30-bd0d-e464769a4f4f`,
}